<template>
  <AuthLayout>
    <LoginFormColaborador />
  </AuthLayout>
</template>

<script setup>
import AuthLayout from "@/layouts/AuthLayout.vue";
import LoginFormColaborador from "@/components/LoginFormColaborador.vue";
</script>
